import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingGrokImagineAiImageGeneratorConfig } from '@/data/landingConfig/landingGrokImagineAiImageGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_GrokImagineAiImageGenerator } from './schemaObject';

interface Props {}
const GrokImagineAiImageGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_GrokImagineAiImageGenerator} />
			<LandingTemplate
				data={landingGrokImagineAiImageGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageGeneratorV2()}
			/>
		</>
	);
};

export default GrokImagineAiImageGenerator;
